var _a;
import core from './core';
// Check Node.js version for native fetch support
if (typeof process !== 'undefined' && ((_a = process.versions) === null || _a === void 0 ? void 0 : _a.node)) {
    var nodeMajorVersion = parseInt(process.versions.node.split('.')[0], 10);
    if (nodeMajorVersion < 18) {
        console.error("[data-relay] Node.js ".concat(process.versions.node, " detected. Native fetch requires Node.js 18+. Please upgrade Node.js or use a polyfill."));
    }
}
// Use native Node.js fetch (available in Node 18+)
var dataRelay = core(null, 'NodeJS SDK');
export default dataRelay;
